import type { ReactNode } from 'react';
import styles from './OptionCard.module.css';

interface OptionCardProps {
  icon: ReactNode;
  title: string;
  description: string;
  onClick?: () => void;
  /** Horizontal row (mobile) vs vertical tile (desktop grid) */
  layout?: 'row' | 'stack';
}

export function OptionCard({ icon, title, description, onClick, layout = 'row' }: OptionCardProps) {
  const rootClass = [styles.card, layout === 'stack' ? styles.cardStack : ''].filter(Boolean).join(' ');
  const icoClass = [styles.ico, layout === 'stack' ? styles.icoStack : ''].filter(Boolean).join(' ');

  return (
    <button type="button" className={rootClass} onClick={onClick}>
      <span className={icoClass} aria-hidden>
        {icon}
      </span>
      <span className={layout === 'stack' ? styles.textStack : undefined}>
        <div className={styles.title}>{title}</div>
        <div className={styles.desc}>{description}</div>
      </span>
      {layout === 'stack' ? (
        <span className={styles.arrow} aria-hidden>
          →
        </span>
      ) : null}
    </button>
  );
}
